<script setup>
import {onMounted, ref, reactive, nextTick} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import moment from "moment";
import {listOperatorAdmin} from "@/api/user/user.js";
import router from "@/router/index.js";
import {tagAuditApplicationTypeEnum} from "@/enum/tagAuditApplicationTypeEnum.js";
import {tagGroupPageList, tagsApplicationList} from "@/api/tag/tag.js";
/*初次加载*/
onMounted(async () => {
  await handleGetOperator('init')
  await handleSearch()
  await handleGetCurrentApprover('init')
})

/*搜索功能*/
// 表单数据
const formData = reactive({
  name: null,
  applicationType: null,
  applicantId: null,
  startTime: null,
  endTime: null,
  currentApproverId: null
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const page = {
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    }
    let param = {
      name: formData.name,
      applicationType: formData.applicationType,
      applicantId: formData.applicantId,
      startTime: formData.startTime ? moment(formData.startTime).startOf('day').format('YYYY-MM-DD HH:mm:ss') : null,
      endTime:formData.endTime ? moment(formData.endTime).endOf('day').format('YYYY-MM-DD HH:mm:ss') : null,
      applicationStateList: ["APPROVED", "REJECTED"],
      currentApproverId: formData.currentApproverId
    }
    console.log("param", param)
    loading.value = true
    const res = tab.value === 'tag' ? await tagsApplicationList(page, param) : await tagGroupPageList(page,param)
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.name = null
  formData.applicationType = null
  formData.applicantId = null
  formData.startTime = null
  formData.endTime = null
  formData.currentApproverId = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
// 标签表头
const tagHeaders = [
  { title: '序号', key: 'order', nowrap: true },
  { title: '名称', key: 'oldDetailData.tagName', nowrap: true },
  { title: '申请操作', key: 'applicationType', nowrap: true },
  { title: '新名称', key: 'detailData.tagName', nowrap: true },
  { title: '申请说明', key: 'applicationReason', nowrap: true },
  { title: '申请人', key: 'applicantName', nowrap: true },
  { title: '申请日期', key: 'crTime', nowrap: true },
  { title: '审核', key: 'applicationState', nowrap: true },
  { title: '审核人', key: 'currentApproverName', nowrap: true },
  { title: '审核日期', key: 'mdTime', nowrap: true },
]
// 标签组表头
const tagGroupHeaders = [
  { title: '序号', key: 'order', nowrap: true },
  { title: '名称', key: 'oldDetailData.tagGroupName', nowrap: true },
  { title: '申请操作', key: 'applicationType', nowrap: true },
  { title: '新名称', key: 'detailData.tagGroupName', nowrap: true },
  { title: '申请说明', key: 'applicationReason', nowrap: true },
  { title: '申请人', key: 'applicantName', nowrap: true },
  { title: '申请日期', key: 'crTime', nowrap: true },
  { title: '审核', key: 'applicationState', nowrap: true },
  { title: '审核人', key: 'currentApproverName', nowrap: true },
  { title: '审核日期', key: 'mdTime', nowrap: true },
]
// 表头信息
const headers = ref(tagHeaders)

// 表格数据
const tableData = ref([])
// 处理切换标签、标签组选项卡
const handleTabChange = (e) => {
  console.log("e", e)
  if (e === 'tag') {
    headers.value = tagHeaders
  } else {
    headers.value = tagGroupHeaders
  }
  handleReset()
}
// 翻页
const handleChangePage = () => {
  handleSearch()
}
// 申请人列表
const memberListArr = ref([])
// 申请人总数条
const memberTotal = ref(0)
// 申请人翻页锚点
const YTTablePaginationMemberRef = ref()
// 处理申请人翻页
const handleChangeMemberPage = () => {
  handleGetOperator()
}
// 申请人列表加载状态
const operatorLoading = ref(false)
// 申请人下拉搜索值
const operatorSelectKey = ref()
// 处理搜索条件列表：申请人
const handleGetOperator = async (type) => {
  await nextTick(async () => {
    try {
      if (type === 'search') {
        YTTablePaginationMemberRef.value.resetPage()
      }
      let param = {
        page: type === 'init' ? 1 : YTTablePaginationMemberRef.value.getPage(),
        pageSize: type === 'init' ? 5 : YTTablePaginationMemberRef.value.getPageSize()
      }
      operatorLoading.value = true
      let res = null
      if (type === 'search') {
        res = await listOperatorAdmin(param, {adminType: 1, nickname: operatorSelectKey.value})
      } else {
        res = await listOperatorAdmin(param, {adminType: 1})
      }
      memberListArr.value = res.list
      memberTotal.value = parseInt(res.total)
      operatorLoading.value = false
    } catch (e) {
      console.log(e)
      operatorLoading.value = false
    }
  })
}
// 处理选择器选择申请人
const handleSelectOperator = (e) => {
  formData.crUserId = e
  console.log("formData", formData)
}

// 审核人列表
const currentApproverListArr = ref([])
// 审核人总数条
const currentApproverTotal = ref(0)
// 审核人翻页锚点
const YTTablePaginationCurrentApproverRef = ref()
// 处理审核人翻页
const handleChangeCurrentApproverPage = () => {
  handleGetCurrentApprover()
}
// 审核人列表加载状态
const currentApproverLoading = ref(false)
// 审核人下拉搜索值
const currentApproverSelectKey = ref()
// 处理搜索条件列表：审核人
const handleGetCurrentApprover = async (type) => {
  await nextTick(async () => {
    try {
      if (type === 'search') {
        YTTablePaginationCurrentApproverRef.value.resetPage()
      }
      let param = {
        page: type === 'init' ? 1 : YTTablePaginationCurrentApproverRef.value.getPage(),
        pageSize: type === 'init' ? 5 : YTTablePaginationCurrentApproverRef.value.getPageSize()
      }
      currentApproverLoading.value = true
      let res = null
      if (type === 'search') {
        res = await listOperatorAdmin(param, {adminType: 1, nickname: currentApproverSelectKey.value})
      } else {
        res = await listOperatorAdmin(param, {adminType: 1})
      }
      currentApproverListArr.value = res.list
      currentApproverTotal.value = parseInt(res.total)
      currentApproverLoading.value = false
    } catch (e) {
      console.log(e)
      currentApproverLoading.value = false
    }
  })
}
// 处理选择器选择审核人
const handleSelectCurrentApprover = (e) => {
  formData.currentApproverId = e
  console.log("formData", formData)
}

// 处理选择器开始日期选择
const handleSelectDate = (date) => {
  console.log("date", date)
  formData.startTime = handleDateFormat(date)
  // 校验结束日期是否小于开始日期
  if (moment(formData.startTime).isAfter(moment(formData.endTime))) {
    formData.endTime = null
  }
}
// 处理选择器结束日期选择
const handleSelectEndDate = (date) => {
  console.log("endDate", date)
  formData.endTime = handleDateFormat(date)
  console.log("form.endTime", formData.endTime)
}
// 处理日期格式
const handleDateFormat = (date) => {
  return moment(date).format('YYYY-MM-DD')
}
// 当前选择的标签卡
const tab = ref("tag")

// 分组状态枚举
const tagAuditType = ref(tagAuditApplicationTypeEnum)
</script>

<template>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="11">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            :item-value="item => `${item.tag?.tagId}-${item.crTime}`"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="center">
                  <v-col cols="1.5">
                    <v-text-field
                        v-model="formData.name"
                        placeholder="请输入名称"
                        label="名称"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="1.5">
                    <v-select
                        v-model="formData.applicationType"
                        placeholder="选择审核结果"
                        variant="outlined"
                        label="审核结果"
                        clearable
                        :items="tagAuditType"
                        item-title="stateName"
                        item-value="stateId"
                    ></v-select>
                  </v-col>
                  <v-col cols="1.5">
                    <v-select
                        ref="operatorListRef"
                        v-model="formData.applicantId"
                        :items="memberListArr"
                        item-title="username"
                        item-value="adminId"
                        label="申请人"
                        variant="outlined"
                        :no-data-text="'没有更多数据了~'"
                        @update:modelValue="handleSelectOperator"
                        :loading="operatorLoading"
                        placeholder="请选择申请人"
                    >
                      <template v-slot:prepend-item>
                        <div class="pd_l_1 pd_r_1 pd_t_1" style="width: 300px">
                          <v-text-field
                              v-model="operatorSelectKey"
                              placeholder="请输入申请人名称"
                              label="申请人名称"
                              variant="outlined"
                              clearable
                              append-inner-icon="mdi-magnify"
                              @click:append-inner="handleGetOperator('search')"
                              @keydown.enter="handleGetOperator('search')"
                              :disabled="operatorLoading"
                          ></v-text-field>
                        </div>
                        <v-divider class="mb-2"></v-divider>
                      </template>
                      <template v-slot:append-item>
                        <v-divider class="mb-2" v-if="memberTotal > 0"></v-divider>
                        <YTTablePagination v-if="memberTotal > 0" ref="YTTablePaginationMemberRef" :pageSize="5" :total="memberTotal" @page-change="handleChangeMemberPage"></YTTablePagination>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="1.5">
                    <v-select
                        ref="currentApproverListRef"
                        v-model="formData.currentApproverId"
                        :items="currentApproverListArr"
                        item-title="username"
                        item-value="adminId"
                        label="审核人"
                        variant="outlined"
                        :no-data-text="'没有更多数据了~'"
                        @update:modelValue="handleSelectCurrentApprover"
                        :loading="currentApproverLoading"
                        placeholder="请选择审核人"
                    >
                      <template v-slot:prepend-item>
                        <div class="pd_l_1 pd_r_1 pd_t_1" style="width: 300px">
                          <v-text-field
                              v-model="currentApproverSelectKey"
                              placeholder="请输入审核人名称"
                              label="审核人名称"
                              variant="outlined"
                              clearable
                              append-inner-icon="mdi-magnify"
                              @click:append-inner="handleGetOperator('search')"
                              @keydown.enter="handleGetOperator('search')"
                              :disabled="currentApproverLoading"
                          ></v-text-field>
                        </div>
                        <v-divider class="mb-2"></v-divider>
                      </template>
                      <template v-slot:append-item>
                        <v-divider class="mb-2" v-if="currentApproverTotal > 0"></v-divider>
                        <YTTablePagination v-if="currentApproverTotal > 0" ref="YTTablePaginationCurrentApproverRef" :pageSize="5" :total="currentApproverTotal" @page-change="handleChangeCurrentApproverPage"></YTTablePagination>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="1.5">
                    <v-select
                        v-model="formData.startTime"
                        :model-value="formData.startTime ? handleDateFormat(formData.startTime) : null"
                        label="开始日期"
                        variant="outlined"
                        placeholder="请选择开始日期"
                        :menu-props="{maxHeight: '550px'}"
                    >
                      <template v-slot:no-data style="max-height: 550px">
                        <div class="flex_center" style="position: relative">
                          <v-date-picker color="#ED5513" title="选择开始日期" :hide-header="false" locale="zh-cn" @update:modelValue="handleSelectDate" v-model="formData.startTime" show-adjacent-months>
                            <template #header>
                              <div class="text-h4" style="box-sizing: border-box;padding: 0 12px 12px 24px"> {{ formData.startTime ? handleDateFormat(formData.startTime) : "请选择开始日期" }}</div>
                            </template>
                          </v-date-picker>
                        </div>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="1.5">
                    <v-select
                        v-model="formData.endTime"
                        :model-value="formData.endTime  ? handleDateFormat(formData.endTime) : null"
                        label="结束日期"
                        variant="outlined"
                        placeholder="请选择结束日期"
                        :menu-props="{maxHeight: '550px'}"
                    >
                      <template v-slot:no-data style="max-height: 550px">
                        <div class="flex_center" style="position: relative">
                          <v-date-picker :min="formData.startTime" color="#ED5513" title="选择结束日期" :hide-header="false" locale="zh-cn" @update:modelValue="handleSelectEndDate" v-model="formData.endTime" show-adjacent-months>
                            <template #header>
                              <div class="text-h4" style="box-sizing: border-box;padding: 0 12px 12px 24px"> {{ formData.endTime ? handleDateFormat(formData.endTime) : "请选择结束日期" }}</div>
                            </template>
                          </v-date-picker>
                        </div>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="2">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="!$handleHasBtnPermission('any', 'memberLevelLog:view')">搜索</v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('any', 'memberLevelLog:view')">重置</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
              <v-tabs
                  class="mg_r_3"
                  v-model="tab"
                  color="primary"
                  @update:modelValue="handleTabChange"
              >
                <v-tab value="tag">标签</v-tab>
                <v-tab value="tagGroup">标签组</v-tab>
              </v-tabs>
            </v-form>
          </template>

          <template v-slot:item.order=" { item, index } ">
            {{index + 1}}
          </template>

          <template v-slot:item.bizType=" { item }">
            <div v-if="item.bizType === 'TAG'">
              标签
            </div>
            <div v-else-if="item.bizType === 'TAG_GROUP'">
              标签分组
            </div>
          </template>

          <template v-slot:item.applicationType=" { item }">
            <div v-if="item.applicationType === 'CREATE'">
              创建
            </div>
            <div v-else-if="item.applicationType === 'EDIT'">
              创建重审
            </div>
            <div v-else-if="item.applicationType === 'DISABLE'">
              禁用
            </div>
            <div v-else-if="item.applicationType === 'ENABLE'">
              启用
            </div>
          </template>

          <template v-slot:item.applicationState=" { item }">
            <el-text v-if="item.applicationState === 'APPROVED'" type="success">通过</el-text>
            <el-text v-if="item.applicationState === 'REJECTED'" type="danger">拒绝</el-text>
          </template>

          <template v-slot:item.crUserName=" { item } ">
            {{item.type === 'SYSTEM' ? 'System' : item.crUserName}}
          </template>

          <template v-slot:item.oldDetailData.tagGroupName=" { item }">
            <span v-if="item.oldDetailData">{{item.oldDetailData?.tagGroupName}}（{{item.oldDetailData?.tagGroupNameEn}}）</span>
          </template>

          <template v-slot:item.oldDetailData.tagName=" { item }">
            <span v-if="item.oldDetailData">{{item.oldDetailData?.tagName}}（{{item.oldDetailData?.tagNameEn}}）</span>
          </template>

          <template v-slot:item.detailData.tagGroupName=" { item }">
            <span v-if="item.applicationType === 'CREATE' || item.applicationType === 'EDIT'">{{item.detailData.tagGroupName}}（{{item.detailData.tagGroupNameEn}}）</span>
          </template>

          <template v-slot:item.detailData.tagName=" { item }">
            <span v-if="item.applicationType === 'CREATE' || item.applicationType === 'EDIT'">{{item.detailData.tagName}}（{{item.detailData.tagNameEn}}）</span>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :pageSize="$globalPageSizeHalf" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>

</style>
